import { CatalogRepository } from '../../domain/repositories/catalog.repository';
import { ProductEntity } from '../../domain/entities/product.entity';

export class GetProductBySlugUseCase {
  constructor(private readonly catalogRepository: CatalogRepository) {}

  async execute(slug: string): Promise<ProductEntity | null> {
    if (!slug || !slug.trim()) {
      throw new Error('El slug del producto es obligatorio');
    }
    return this.catalogRepository.getProductBySlug(slug.trim());
  }
}
